"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderCardImage = exports.renderButton = void 0;
var _react = _interopRequireDefault(require("react"));
var _generateFocusedImageAlt = _interopRequireDefault(require("../../utils/generateFocusedImageAlt"));
var _Video = _interopRequireDefault(require("../Video/Video"));
var _renderImageOrLottieAnimation = require("../../utils/renderImageOrLottieAnimation");
var _Button = _interopRequireDefault(require("../Button/Button"));
var _Icon = _interopRequireDefault(require("../../components/Icon/Icon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const renderCardImage = (image, imageSizes, modalContent, modalType, deployModal, hideModal, modalDeployed) => {
  if (image && modalContent?.video && modalType && modalType !== "No Modal") {
    return /*#__PURE__*/_react.default.createElement("figure", {
      role: "none",
      className: "ter-bounded-card__image ter-unbounded-card__image--with-modal",
      "data-sb-field-path": "cardImage"
    }, /*#__PURE__*/_react.default.createElement(_Video.default, {
      content: modalContent
    }));
  } else if (image && imageSizes && modalType && modalType !== "No Modal" && image?.type !== "lottieAnimation") {
    const thumbnailImage = image?.focalPointImage ? image?.focalPointImage : image;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("figure", {
      role: "none",
      className: `ter-bounded-card__image ter-unbounded-card__image--with-modal ${image?.type === 'lottieAnimation' ? "ter-unbounded-card__image--lottie" : ""}`,
      onClick: () => deployModal(),
      "data-sb-field-path": "cardImage"
    }, (0, _renderImageOrLottieAnimation.renderImageOrLottieAnimation)(thumbnailImage, null, imageSizes?.thumbnail, (0, _generateFocusedImageAlt.default)(thumbnailImage), "ter-bounded-card__thumb", null, true, {
      width: 3,
      height: 2
    }), modalContent && /*#__PURE__*/_react.default.createElement("div", {
      className: "ter-unbounded-card__magnify"
    }, /*#__PURE__*/_react.default.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      className: "ter-unbounded-card__magnify-icon"
    }, /*#__PURE__*/_react.default.createElement("path", {
      fill: "#fff",
      d: "m12.0885 11.0603 3.1087 3.1079-1.0271 1.027-3.1079-3.1086c-1.15636.927-2.59472 1.4312-4.07682 1.4291-3.6058 0-6.532255-2.9265-6.532255-6.53227 0-3.60581 2.926455-6.532258 6.532255-6.532258 3.60582 0 6.53222 2.926448 6.53222 6.532258.0022 1.4821-.5021 2.92046-1.4291 4.07687Zm-1.4559-.5386c.9211-.94722 1.4355-2.21699 1.4334-3.53827 0-2.80742-2.27392-5.08065-5.08062-5.08065-2.80742 0-5.08064 2.27323-5.08064 5.08065 0 2.80669 2.27322 5.08067 5.08064 5.08067 1.32128.0021 2.59105-.5124 3.53832-1.4335l.1089-.1089ZM6.25958 6.25762V4.0802h1.45161v2.17742h2.17742v1.45162H7.71119v2.17742H6.25958V7.70924H4.08216V6.25762h2.17742Z"
    })))), renderModal(modalType, imageSizes, modalContent ? modalContent : image, modalDeployed, hideModal));
  } else {
    return /*#__PURE__*/_react.default.createElement("figure", {
      role: "none",
      className: "ter-bounded-card__image",
      "data-sb-field-path": "cardImage"
    }, (0, _renderImageOrLottieAnimation.renderImageOrLottieAnimation)(image, null, imageSizes?.thumbnail || imageSizes, (0, _generateFocusedImageAlt.default)(image), "ter-bounded-card__thumb", null));
  }
};
exports.renderCardImage = renderCardImage;
const renderModal = (modalType, imageSizes, modalContent, modalDeployed, hideModal) => {
  const modalLottieAnimation = {
    height: "100vh"
  };
  if (modalType === "Image") {
    return modalDeployed && /*#__PURE__*/_react.default.createElement("div", {
      className: `ter-unbounded-card-modal ${modalDeployed ? `ter-unbounded-card-modal--deployed` : ""}`
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "ter-unbounded-card-modal__close-wrapper",
      onClick: () => {
        hideModal();
      }
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      color: "#ffffff",
      type: "ter-icon--open-x-dark-48px",
      size: "32px",
      className: "ter-unbounded-card-modal__close-button"
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "default-layout"
    }, (0, _renderImageOrLottieAnimation.renderImageOrLottieAnimation)(modalContent?.modalImage?.focalPointImage ? modalContent?.modalImage?.focalPointImage : modalContent?.modalImage, null, imageSizes?.modal, (0, _generateFocusedImageAlt.default)(modalContent), "ter-unbounded-card__modal-image", modalLottieAnimation)));
  }
};
const renderButton = (buttonContent, Link) => {
  return /*#__PURE__*/_react.default.createElement(_Button.default, {
    name: buttonContent?.name || null,
    text: buttonContent?.text || null,
    className: buttonContent?.type || "ter-button--primary--1",
    onClick: buttonContent?.onClick || null,
    url: buttonContent?.url || null,
    external: buttonContent?.external || false,
    Link: Link,
    VideoComponent: _Video.default ? _Video.default : null,
    video: buttonContent?.video ? buttonContent?.video : null,
    setOverride: buttonContent?.setOverride ? buttonContent?.setOverride : null,
    override: buttonContent?.override ? buttonContent?.override : null
  });
};
exports.renderButton = renderButton;